import { render, staticRenderFns } from "./CustomUIProject.vue?vue&type=template&id=7d8c21ce&scoped=true&"
import script from "./CustomUIProject.vue?vue&type=script&lang=js&"
export * from "./CustomUIProject.vue?vue&type=script&lang=js&"
import style0 from "./CustomUIProject.vue?vue&type=style&index=0&id=7d8c21ce&prod&scoped=true&lang=css&"
import style1 from "./CustomUIProject.vue?vue&type=style&index=1&id=7d8c21ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c21ce",
  null
  
)

export default component.exports